import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
// @ts-ignore Could not find a declaration file for module
import { useSearchParam } from '../../../hooks/searchParamHooks';
import UsageTracker from '../../../utils/UsageTracker';
import { Select } from 'foundations-components/transitional/components/Select';
import { FilterButton } from './FilterButton';
import { DownCaratIcon } from 'foundations-assets/icons/components/DownCaratIcon';
import { jsx as _jsx } from "react/jsx-runtime";
function ButtonContent({
  value
}) {
  if (value === 'ASSIGNED') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.topFilters.assignment.filterTitleWithValue",
      options: {
        value: I18n.text('learningCenter.topFilters.assignment.ASSIGNED_TO_ME')
      }
    });
  }
  if (value === 'NOT_ASSIGNED') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.topFilters.assignment.filterTitleWithValue",
      options: {
        value: I18n.text('learningCenter.topFilters.assignment.NOT_ASSIGNED')
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.topFilters.assignment.filterTitle"
  });
}
export function DropdownAssignmentFilter({
  appearsIn
}) {
  const [[assignment], setAssignment] = useSearchParam(FILTER_TYPES.ASSIGNMENT);
  const handleChange = value => {
    UsageTracker.trackStandalone('Filter Interaction', {
      action: value ? 'filter-selected' : 'filter-deselected',
      value,
      key: 'assignment-filter',
      appearsIn,
      isDropdown: true
    });
    setAssignment(value);
  };
  const options = [{
    text: I18n.text('learningCenter.topFilters.assignment.ASSIGNED_TO_ME'),
    value: 'ASSIGNED'
  }, {
    text: I18n.text('learningCenter.topFilters.assignment.NOT_ASSIGNED'),
    value: 'NOT_ASSIGNED'
  }];
  return /*#__PURE__*/_jsx(FilterButton, {
    isFilterActive: !!assignment,
    onClear: () => handleChange(null),
    testId: "remove-assignment-filter",
    children: /*#__PURE__*/_jsx(Select, {
      ButtonContent: ButtonContent,
      anchorType: "button",
      buttonContentProps: {
        value: assignment
      },
      buttonUse: "transparent",
      caretRenderer: () => /*#__PURE__*/_jsx(DownCaratIcon, {
        color: "icon-interactive-default",
        size: "100"
      }),
      "data-test-id": "filter-type-assignment",
      menuWidth: 200,
      onChange: evt => handleChange(evt.target.value || null),
      options: options,
      value: assignment
    })
  });
}